import React from 'react';

import { T } from 'react-translator-component';

import { UserDashboardProps } from '../../../types/responses/UsersDashboard';

const MPT = ['Sem Nome', T('Undefined')];
export interface UsersInnerData {
  user_pk?: number;
  user_name?: string;
  email?: string;
  ocpp_id_tag?: string;
  docType?: string;
  docNumber?: string;
  is_vehicle?: boolean;
}

const innerDataFormater = ({ ...rest }: UserDashboardProps) => {
  return rest;
};

const listFormater = (list: UserDashboardProps[], isVehicle) => {
  let cardsList: any = [];
  let innerData: any = [];

  list !== undefined &&
    list.forEach((user) => {
      const baseList = [
        {
          value: user?.user_pk || MPT[1],
          subValue: '',
          icon: <></>,
          size: '8%',
        },
        {
          value: (!!user?.user_name?.trim() && user?.user_name) || MPT[0],
          subValue: '',
          icon: <></>,
          size: isVehicle ? '25%' : '30%',
        },
      ];

      if (isVehicle) {
        baseList.push(
          {
            value:
              (!!user?.company_name?.trim() && user?.company_name) ||
              T('No company'),
            subValue: '',
            icon: <></>,
            size: '67%',
          },
        );
      } else {
        baseList.push(
          {
            value: user?.docNumber
              ? (user?.docType === 'FOREIGN' || user?.docType === 'FO' ? 'FO' : user?.docType) + ': ' + user?.docNumber
              : 'Não cadastrado',
            subValue: '',
            icon: <></>,
            size: '25%',
          },
          {
            value:
              `${user?.car_brand_name} ${user?.car_model_name}` ||
              T('Undefined'),
            subValue: '',
            icon: <></>,
            size: '37%',
          },
        );
      }

      cardsList = [...cardsList, baseList];

      innerData = [...innerData, innerDataFormater(user)];
    });

  return { cardsList, innerData };
};

export const combiningObjects = (
  list: UserDashboardProps[],
  header,
  isVehicle,
) => {
  return {
    header,
    ...listFormater(list, isVehicle),
  };
};
